import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { NavLink } from 'react-router-dom';
import './Callus.css';

var bnr1 = require('./../../images/background/bg-4.png');

const contactEmail =
  (process.env.REACT_APP_VSM_CONTACT_TO_EMAIL || 'hello@vsmrenovations.com').trim();

const syncFilledClass = (field) => {
  const wrap = field.closest('.input.input-animate');
  if (!wrap) return;
  const hasValue = (field.value || '').length > 0;
  wrap.classList.toggle('callus-filled', hasValue);
};

const Callus = () => {
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const formRef = useRef(null);

  const refreshFilledStates = useCallback(() => {
    const root = formRef.current;
    if (!root) return;
    root.querySelectorAll('.input.input-animate input, .input.input-animate textarea').forEach(syncFilledClass);
  }, []);

  useEffect(() => {
    refreshFilledStates();
    const t1 = setTimeout(refreshFilledStates, 100);
    const t2 = setTimeout(refreshFilledStates, 600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [refreshFilledStates]);

  const handleFormInput = useCallback((e) => {
    const t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) {
      syncFilledClass(t);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const workerUrl = process.env.REACT_APP_CONTACT_WORKER_URL;
    // if (!workerUrl) {
    //   setStatus({ type: 'error', text: 'Contact form is not configured (set REACT_APP_CONTACT_WORKER_URL).' });
    //   return;
    // }
    const form = e.currentTarget;
    const fd = new FormData(form);
    const payload = {
      name: (fd.get('username') || '').toString().trim(),
      email: (fd.get('email') || '').toString().trim(),
      phone: (fd.get('phone') || '').toString().trim(),
      message: (fd.get('message') || '').toString().trim(),

      to: contactEmail,
    };
    setStatus(null);
    setSubmitting(true);
    try {
      const res = await fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setStatus({ type: 'error', text: data.error || 'Something went wrong. Please try again.' });
        return;
      }
      setStatus({ type: 'ok', text: 'Thanks — we received your message and will get back to you soon.' });
      form.reset();
    } catch {
      setStatus({ type: 'error', text: 'Network error. Check your connection and try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="section-full mobile-page-padding mission-outer-section  p-t80 p-b50 bg-gray bg-no-repeat bg-right-center" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
        <div className="section-content">
          <div className="container">
            {/* TITLE END */}
            <div className="our-mission-cta-row">
              <div className="our-mission-cta-row__cell">
                <div className="section-content bg-primary p-a30 our-mission-cta-row__fill">
                  <div className="call-us-section text-center">
                    <h4 className="m-b15">Let's work together</h4>
                    <h2 className="call-us-number m-b15 m-b0">(+1)-226-980-8873</h2>
                    <h4 className="call-us-address m-t0 m-b20">6076 Decker Dr, London, ON N6P 1J5, Canada</h4>
                    <h4 className="call-us-address m-t0 m-b20">
                      <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                    </h4>
                    {/* <NavLink to="/contactus" className="site-button-secondry btn-effect bg-dark text-uppercase">Contact Us</NavLink> */}

                  </div>
                </div>
              </div>

              <div className="our-mission-cta-row__cell">
                <div className="contact-home1-left bg-dark p-a30 m-b0 our-mission-cta-row__form">
                  <h3 className="text-white m-t0"><span className="font-weight-100">Get In</span> Touch</h3>
                  <form
                    ref={formRef}
                    className="cons-contact-form2 form-transparent callus-form"
                    method="post"
                    action=""
                    onSubmit={handleSubmit}
                    onInput={handleFormInput}
                  >
                    <div className="input input-animate">
                      <label htmlFor="name">Name</label>
                      <input type="text" name="username" id="name" autoComplete="name" required />
                      <span className="spin" />
                    </div>
                    <div className="input input-animate">
                      <label htmlFor="email">Email</label>
                      <input type="email" name="email" id="email" autoComplete="email" required />
                      <span className="spin" />
                    </div>
                    <div className="input input-animate">
                      <label htmlFor="Phone">Phone</label>
                      <input type="tel" name="phone" id="Phone" autoComplete="tel" required />
                      <span className="spin" />
                    </div>
                    <div className="input input-animate input-animate--multiline">
                      <label htmlFor="message">Message</label>
                      <textarea name="message" id="message" rows={4} autoComplete="off" required defaultValue={""} />
                      <span className="spin" />
                    </div>
                    <div className="text-right p-t10">
                      <button type="submit" className="site-button btn-effect text-uppercase" disabled={submitting}>
                        {submitting ? 'Sending…' : 'Submit Now'}
                      </button>
                    </div>
                    {status ? (
                      <p
                        className={`callus-form-status callus-form-status--${status.type}`}
                        role="status"
                        aria-live="polite"
                      >
                        {status.text}
                      </p>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Callus;
